import actions from './actions';
import authActions from '../auth/actions';

const initState = {
  errorMessage: null,
  isError: false,
  message: null,
  loading: false,
  roleData: null,
  roleLoading: false,
  userData: null,
  userPagination: null,
  userLoading: false,
  userFilter: null,
  userLoadMoreLoading: false,
  activeRole: null,
  industryData: null,
  industryLoading: false,
  addressData: null,
  addressLoading: false,
  provinceData: null,
  regionData: null,
  pageLoading: false,
  lookupsData: null,
  lookupsLoading: false,
  btnLoading: false,
  moduleData: null,
  moduleLoading: false,
  paymentChannel: null,
  paymentChannelLoading: false,
  paymentChannelIsError: false,
  notificationData: null,
  notificationLoading: false,
  notificationIsError: false,
  isErrorAppSettings: false,
  appSettingsLoading: false,
  appSettingsErrorMessage: null,

  newLookupsData: null,
  newLookupsLoading: false,
  newLookupsEdited: false,

  userActivityLoadMore: false,
  userActivityIsError: false,
  userActivityLoading: false,
  userActivityData: null,
  userActivityFilter: null,

  systemLoading: false,

  userListByRoleID: null,
  userListByRoleIDLoading: false,
  userListByRoleIDIsError: false,
  externalRecipientData: null,
  externalRecipientLoading: false,
  externalRecipientIsError: false,

  users: null,
  usersLoading: false,
  usersIsError: false,

  lookupValidationData: null,
  lookupValidationLoading: false,
  lookupValidationIsError: false,

  paymentChannelListLoading: false,
  paymentChannelListData: null,
  paymentChannelListIsError: false,

  paymentMethodListLoading: false,
  paymentMethodListData: null,
  paymentMethodListIsError: false,
  paymentChannelFilter: ['all'],

  templateDataLoading: false,
  templateData: null,
  templateDataIsError: false,

  bankTemplateDataLoading: false,
  bankTemplateData: null,
  bankTemplateDataIsError: false,

  fileLoading: false,
  isFileError: false,

  preSignedURLLoading: false,
  preSignedURL: null,
  preSignedURLIsError: false,

  uploadedFilesLoading: false,
  uploadedFiles: null,
  uploadedFilesIsError: false,
  uploadedChannel: null,
  uploadedFilesPagination: null,

  cosmosLogsLoading: false,
  cosmosLogs: null,
  cosmosLogsPagination: null,
  cosmosLogsIsError: false,
  cosmosLogsFilter: null,

  systemSettingsLoading: false,
  systemSettings: null,
  systemSettingsIsError: false,

  presignedListLoading: false,
  presignedListURLs: [],
  presignedListIsError: false,

  bankFileUploadIsError: false,
  bankFileUploadLoading: false,

  paynamicsBanks: null,
  paynamicsBanksLoading: false,
  paynamicsBanksIsError: false,
  addPaynamicsBanksIsError: false,
  addPaynamicsBankLoading: false,
  editPaynamicsBanksIsError: false,
  editPaynamicsBankLoading: false,

  otpServiceLoading: false,
  otpServiceData: null,
  otpServiceIsError: false,

  otpServiceTemplateLoading: false,
  otpServiceTemplateData: null,
  otpServiceTemplateIsError: false,

  testGenerateOTPLoading: false,
  testGenerateOTPData: null,
  testGenerateOTPIsError: false,

  activeOTPService: null,
  isResetOTPServiceActiveData: false,

  otpIntegratorsLoading: false,
  otpIntegratorsData: null,
  otpIntegratorsIsError: false,

  otpLogs: null,
  otpLogsFilter: null,
  otpLogsIsLoading: false,
  otpLogsIsError: false,
  otpLogsPagination: null,

  otpLogsActionCount: null,
  otpLogsActionCountFilter: null,
  otpLogsActionCountIsLoading: false,
  otpLogsActionCountIsError: false,
  otpLogsActionCountPagination: null,

  pageActionLoading: false,
  pageActionIsError: false,

  currentItemLogs: null,
  currentItemLogsIsLoading: false,
  currentItemLogsIsError: false,
  currentItemLogPagination: null,
  invitedUserDataLoading: false,
  invitedUserData: null,
  invitedUserDataIsError: false,

  allInvitedUsersDataLoading: false,
  allInvitedUsersData: null,
  allInvitedUsersDataIsError: false,
  allInvitedUsersDataPagination: false,

  signUpUserStatus: false,

  allUserDeptData: null,
  allUserDeptLoading: false,

  logAccessLoading: false,

  paymentChannelPayloadById: null,
  paymentChannelPayloadByIdLoading: false,
  paymentChannelPayloadByIdHasError: false,

  installmentModePayloadById: null,
  installmentModePayloadByIdLoading: false,
  installmentModePayloadByIdHasError: false,

  subChannelPayloadById: null,
  subChannelPayloadByIdLoading: false,
  subChannelPayloadByIdHasError: false,

  merchantSpecificPayloadById: null,
  merchantSpecificPayloadByIdLoading: false,
  merchantSpecificPayloadByIdHasError: false,

  merchantSpecificPayloadsData: null,
  merchantSpecificPayloadsLoading: false,
  merchantSpecificPayloadsDataIsError: false,

  paymentChannelConfigurationsData: null,
  paymentChannelConfigurationsLoading: false,
  paymentChannelConfigurationsDataIsError: false,

  integrationManagementIsError: false,
  integrationManagementLoading: false,
  integrationManagementData: null,
  integrationManagementFilter: null,

  integrationManagementById: null,
  integrationManagementByIdLoading: false,
  integrationManagementByIdHasError: false,

  generateNewAPIKeyLoading: false,

  reconAuditLogs: [],
  reconAuditLogsPagination: null,
  reconAuditLogsIsLoading: false,
  reconAuditLogsIsError: false,
  reconAuditLogsFilter: null,

  loadingMoreReconAuditLogs: false
  
};

export default function merchantReducer(state = initState, action) {
  switch (action.type) {
    case actions.CLEAR_MESSAGE:
      return {
        ...state,
        errorMessage: null,
        isError: false,
        paymentChannelIsError: false,
        notificationIsError: false
      };
    case actions.FETCHING_ROLE_DATA:
      return {
        ...state,
        roleData: null,
        pageLoading: action.loading,
        roleLoading: action.loading
      };

    case actions.FETCH_ROLE_DATA_SUCCESS:
      return {
        ...state,
        roleLoading: action.loading,
        pageLoading: action.loading,
        roleData: action.result,
        isError: false
      };

    case actions.FETCH_OTP_SERVICE_DATA_FAILED:
      return {
        ...state,
        otpServiceLoading: action.loading,
        otpServiceData: action.result,
        otpServiceIsError: true
      };

    case actions.FETCHING_OTP_SERVICE_DATA:
      return {
        ...state,
        otpServiceLoading: true,
        otpServiceData: null
      };

    case actions.FETCH_OTP_SERVICE_DATA_SUCCESS:
      return {
        ...state,
        otpServiceLoading: action.loading,
        otpServiceData: action.result,
        otpServiceIsError: false
      };

    case actions.FETCH_OTP_SERVICE_TEMPLATE_DATA_FAILED:
      return {
        ...state,
        otpServiceTemplateLoading: action.loading,
        otpServiceTemplateData: action.result,
        otpServiceTemplateIsError: true
      };

    case actions.FETCHING_OTP_SERVICE_TEMPLATE_DATA:
      return {
        ...state,
        otpServiceTemplateLoading: true,
        otpServiceTemplateData: null
      };

    case actions.FETCH_OTP_SERVICE_TEMPLATE_DATA_SUCCESS:
      return {
        ...state,
        otpServiceTemplateLoading: action.loading,
        otpServiceTemplateData: action.result,
        otpServiceTemplateIsError: false
      };

    case actions.SET_IS_RESET_OTP_SERVICE_ACTIVE_DATA:
      return {
        ...state,
        isResetOTPServiceActiveData: action.payload
      };

    case actions.SET_ACTIVE_OTP_SERVICE:
      return {
        ...state,
        activeOTPService: action.otpService
      };

    case actions.FETCH_ROLE_DATA_FAILED:
      return {
        ...state,
        roleLoading: action.loading,
        pageLoading: action.loading,
        roleData: action.result,
        isError: true
      };

    case actions.FETCHING_OTP_INTEGRATORS:
      return {
        ...state,
        otpIntegratorsLoading: true,
        otpIntegratorsData: null
      };

    case actions.FETCH_OTP_INTEGRATORS_SUCCESS:
      return {
        ...state,
        otpIntegratorsLoading: action.loading,
        otpIntegratorsData: action.result,
        otpIntegratorsIsError: false
      };

    case actions.FETCH_OTP_INTEGRATORS_FAILED:
      return {
        ...state,
        otpIntegratorsLoading: action.loading,
        otpIntegratorsData: action.result,
        otpIntegratorsIsError: true
      };

    case actions.FETCHING_OTP_LOGS:
      return {
        ...state,
        otpLogsIsLoading: action.loading,
        otpLogsIsError: false
      };

    case actions.FETCH_OTP_LOGS_SUCCESS:
      return {
        ...state,
        otpLogs: action.result,
        otpLogsIsLoading: action.loading,
        otpLogsIsError: false,
        otpLogsPagination: action.pagination,
        otpLogsFilter: action.filter
      };

    case actions.FETCH_OTP_LOGS_FAILED:
      return {
        ...state,
        otpLogsIsLoading: action.loading,
        otpLogsIsError: true
      };

    case actions.FETCHING_OTP_LOGS_ACTION_COUNT:
      return {
        ...state,
        otpLogsActionCountIsLoading: action.loading,
        otpLogsActionCountIsError: false
      };

    case actions.FETCH_OTP_LOGS_ACTION_COUNT_SUCCESS:
      return {
        ...state,
        otpLogsActionCount: action.result,
        otpLogsActionCountIsLoading: action.loading,
        otpLogsActionCountIsError: false,
        otpLogsActionCountFilter: action.filter
      };

    case actions.FETCH_OTP_LOGS_ACTION_COUNT_FAILED:
      return {
        ...state,
        otpLogsActionCountIsLoading: action.loading,
        otpLogsActionCountIsError: true
      };

    case actions.FETCHING_ADDRESSES_DATA:
      return {
        ...state,
        addressData: null,
        provinceData: null,
        regionData: null,
        pageLoading: action.loading,
        addressLoading: action.loading
      };

    case actions.FETCH_ADDRESSES_DATA_SUCCESS:
      return {
        ...state,
        addressLoading: action.loading,
        pageLoading: action.loading,
        addressData: action.result.address,
        provinceData: action.result.province,
        regionData: action.result.region,
        isError: false
      };

    case actions.FETCH_ADDRESSES_DATA_FAILED:
      return {
        ...state,
        addressLoading: action.loading,
        pageLoading: action.loading,
        addressData: action.result,
        isError: true
      };

    case actions.FETCHING_ROLE_DATA_BY_ID:
      return {
        ...state,
        activeRole: null,
        pageLoading: action.loading
      };

    case actions.FETCH_ROLE_DATA_BY_ID_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        activeRole: action.result,
        isError: false
      };

    case actions.FETCH_ROLE_DATA_BY_ID_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        activeRole: action.result,
        isError: true
      };

    case actions.FETCHING_ALL_USER_DEPT_DATA:
      return {
        ...state,
        allUserDeptLoading: true
      };

    case actions.FETCH_ALL_USER_DEPT_DATA_SUCCESS:
      return {
        ...state,
        allUserDeptLoading: false,
        allUserDeptData: action.result,
        isError: false
      };

    case actions.FETCH_ALL_USER_DEPT_DATA_FAILED:
      return {
        ...state,
        allUserDeptLoading: action.loading,
        allUserDeptData: action.result,
        isError: true
      };

    case actions.FETCHING_USER_DATA:
      return {
        ...state,
        pageLoading: true,
        userLoading: action.loading
      };

    case actions.FETCH_USER_DATA_SUCCESS:
      return {
        ...state,
        userLoading: action.loading,
        pageLoading: false,
        userData: action.result,
        isError: false,
        userPagination: action.pagination,
        userFilter: action.filter,
        userLoadMoreLoading: false
      };

    case actions.LOADING_MORE_USER_DATA:
      return {
        ...state,
        userLoadMoreLoading: true
      };

    case actions.FETCH_USER_DATA_FAILED:
      return {
        ...state,
        userLoading: action.loading,
        pageLoading: action.loading,
        userData: action.result,
        isError: true
      };

    case actions.ADDING_ROLE_DATA:
      return {
        ...state,
        isError: false,
        roleLoading: true,
        pageLoading: true
      };

    case actions.ADD_ROLE_DATA_SUCCESS:
      return {
        ...state,
        roleLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.ADD_ROLE_DATA_FAILED:
      return {
        ...state,
        roleLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };
    case actions.EDITING_ROLE_DATA:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.EDIT_ROLE_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading
      };

    case actions.EDIT_ROLE_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.ADDING_USER_DATA:
      return {
        ...state,
        isError: false,
        userLoading: true,
        pageLoading: action.loading
      };

    case actions.ADD_USER_DATA_SUCCESS:
      return {
        ...state,
        userLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading
      };

    case actions.ADD_USER_DATA_FAILED:
      return {
        ...state,
        userLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.INVITING_USER_DATA:
      return {
        ...state,
        isError: false,
        userLoading: true,
        pageLoading: action.loading
      };

    case actions.INVITE_USER_DATA_SUCCESS:
      return {
        ...state,
        userLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading
      };

    case actions.INVITE_USER_DATA_FAILED:
      return {
        ...state,
        userLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.RESEND_INVITING_USER_DATA:
      return {
        ...state,
        isError: false,
        userLoading: true,
        pageLoading: action.loading
      };

    case actions.RESEND_INVITE_USER_DATA_SUCCESS:
      return {
        ...state,
        userLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading
      };

    case actions.RESEND_INVITE_USER_DATA_FAILED:
      return {
        ...state,
        userLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.SIGNING_UP_USER_DATA:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading,
        signUpUserStatus: false
      };

    case actions.SIGN_UP_USER_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        signUpUserStatus: true
      };

    case actions.SIGN_UP_USER_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading,
        signUpUserStatus: false
      };

    case actions.FETCHING_INVITED_USER_DATA:
      return {
        ...state,
        invitedUserData: null,
        invitedUserDataLoading: action.loading
      };

    case actions.FETCH_INVITED_USER_DATA_SUCCESS:
      return {
        ...state,
        invitedUserDataLoading: action.loading,
        invitedUserData: action.result,
        invitedUserDataIsError: false
      };

    case actions.FETCH_INVITED_USER_DATA_FAILED:
      return {
        ...state,
        invitedUserDataLoading: action.loading,
        invitedUserData: action.result,
        invitedUserDataIsError: true
      };

    case actions.LOGGING_ACCESS_INVITE_DATA:
      return {
        ...state,
        isError: false,
        logAccessLoading: true,
        pageLoading: action.loading
      };

    case actions.LOG_ACCESS_INVITE_DATA_SUCCESS:
      return {
        ...state,
        logAccessLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading
      };

    case actions.LOG_ACCESS_INVITE_DATA_FAILED:
      return {
        ...state,
        logAccessLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.FETCHING_ALL_INVITED_USERS_DATA:
      return {
        ...state,
        allInvitedUsersData: null,
        // pageLoading: action.loading,
        allInvitedUsersDataLoading: action.loading
      };

    case actions.FETCH_ALL_INVITED_USERS_DATA_SUCCESS:
      return {
        ...state,
        allInvitedUsersDataLoading: action.loading,
        // pageLoading: action.loading,
        allInvitedUsersData: action.result,
        allInvitedUsersDataIsError: false,
        allInvitedUsersDataPagination: action.pagination
      };

    case actions.FETCH_ALL_INVITED_USERS_DATA_FAILED:
      return {
        ...state,
        allInvitedUsersDataLoading: action.loading,
        // pageLoading: action.loading,
        allInvitedUsersData: action.result,
        allInvitedUsersDataIsError: true,
        allInvitedUsersDataPagination: action.pagination
      };

    case actions.FETCHING_LOOKUPS_DATA:
      return {
        ...state,
        lookupsData: null,
        pageLoading: action.loading,
        lookupsLoading: action.loading
      };

    case actions.FETCH_LOOKUPS_DATA_SUCCESS:
      return {
        ...state,
        lookupsLoading: action.loading,
        pageLoading: action.loading,
        lookupsData: action.result,
        isError: false
      };

    case actions.FETCH_LOOKUPS_DATA_FAILED:
      return {
        ...state,
        lookupsLoading: action.loading,
        pageLoading: action.loading,
        lookupsData: action.result,
        isError: true
      };

    case actions.FETCHING_LOOKUPS_DATA_REVAMPED:
      return {
        ...state,
        newLookupsData: null,
        pageLoading: action.loading,
        newLookupsLoading: action.loading
      };

    case actions.FETCH_LOOKUPS_DATA_REVAMPED_SUCCESS:
      return {
        ...state,
        newLookupsLoading: action.loading,
        pageLoading: action.loading,
        newLookupsData: action.result,
        isError: false
      };

    case actions.FETCH_LOOKUPS_DATA_REVAMPED_FAILED:
      return {
        ...state,
        newLookupsLoading: action.loading,
        pageLoading: action.loading,
        newLookupsData: action.result,
        isError: true
      };

    case actions.EDITED_LOOKUPS_DATA:
      return {
        ...state,
        newLookupsEdited: action.edited
      };

    case actions.FETCHING_INDUSTRY_DATA:
      return {
        ...state,
        industryData: null,
        pageLoading: action.loading,
        industryLoading: action.loading
      };

    case actions.FETCH_INDUSTRY_DATA_SUCCESS:
      return {
        ...state,
        industryLoading: action.loading,
        pageLoading: action.loading,
        industryData: action.result,
        isError: false
      };

    case actions.FETCH_INDUSTRY_DATA_FAILED:
      return {
        ...state,
        industryLoading: action.loading,
        pageLoading: action.loading,
        industryData: action.result,
        isError: true
      };

    case actions.ADDING_LOOKUPS_DATA:
      return {
        ...state,
        isError: false,
        lookupsLoading: true,
        pageLoading: true
      };

    case actions.ADD_LOOKUPS_DATA_SUCCESS:
      return {
        ...state,
        lookupsLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.ADD_LOOKUPS_DATA_FAILED:
      return {
        ...state,
        lookupsLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.EDITING_LOOKUPS_DATA:
      return {
        ...state,
        isError: false,
        lookupsLoading: true,
        pageLoading: action.loading
      };

    case actions.EDIT_LOOKUPS_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        lookupsLoading: false,
        pageLoading: action.loading
      };

    case actions.EDIT_LOOKUPS_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        lookupsLoading: false,
        pageLoading: action.loading
      };

    case actions.EDITING_SYSTEM_MODULE_STATUS:
      return {
        ...state,
        isError: false,
        systemLoading: true
      };

    case actions.EDIT_SYSTEM_MODULE_STATUS_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        systemLoading: false
      };

    case actions.EDIT_SYSTEM_MODULE_STATUS_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        systemLoading: false
      };

    case actions.EDITING_LOOKUP_GROUP_DATA:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading,
        lookupsLoading: true
      };

    case actions.EDIT_LOOKUP_GROUP_DATA_SUCCESS:
      return {
        ...state,
        isError: false,
        errorMessage: action.message,
        lookupsLoading: false,
        pageLoading: action.loading
      };

    case actions.EDIT_LOOKUP_GROUP_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        lookupsLoading: false,
        isError: true,
        pageLoading: action.loading
      };

    case actions.ADDING_INDUSTRY_DATA:
      return {
        ...state,
        isError: false,
        industryLoading: true,
        pageLoading: true
      };

    case actions.ADD_INDUSTRY_DATA_SUCCESS:
      return {
        ...state,
        industryLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.ADD_INDUSTRY_DATA_FAILED:
      return {
        ...state,
        industryLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.EDITING_INDUSTRY_DATA:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading,
        industryLoading: action.loading
      };

    case actions.EDIT_INDUSTRY_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        industryLoading: action.loading
      };

    case actions.EDIT_INDUSTRY_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading,
        industryLoading: action.loading
      };

    case actions.ADDING_ADDRESS_DATA:
      return {
        ...state,
        isError: false,
        addressLoading: true,
        pageLoading: true
      };

    case actions.ADD_ADDRESS_DATA_SUCCESS:
      return {
        ...state,
        addressLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.ADD_ADDRESS_DATA_FAILED:
      return {
        ...state,
        addressLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.ADDING_OTP_SERVICE_DATA:
      return {
        ...state,
        otpServiceIsError: false,
        otpServiceLoading: true,
        pageLoading: true
      };

    case actions.ADD_OTP_SERVICE_DATA_SUCCESS:
      return {
        ...state,
        otpServiceLoading: action.loading,
        errorMessage: action.message,
        otpServiceIsError: false,
        pageLoading: false
      };

    case actions.ADD_OTP_SERVICE_DATA_FAILED:
      return {
        ...state,
        otpServiceLoading: action.loading,
        errorMessage: action.message,
        otpServiceIsError: true,
        pageLoading: false
      };

    case actions.ADDING_OTP_SERVICE_TEMPLATE_DATA:
      return {
        ...state,
        otpServiceTemplateIsError: false,
        otpServiceTemplateLoading: true
        // pageLoading: true
      };

    case actions.ADD_OTP_SERVICE_TEMPLATE_DATA_SUCCESS:
      return {
        ...state,
        otpServiceTemplateLoading: action.loading,
        errorMessage: action.message,
        otpServiceTemplateIsError: false
        // pageLoading: false
      };

    case actions.ADD_OTP_SERVICE_TEMPLATE_DATA_FAILED:
      return {
        ...state,
        otpServiceTemplateLoading: action.loading,
        errorMessage: action.message,
        otpServiceTemplateIsError: true
        // pageLoading: false
      };

    case actions.TESTING_GENERATE_OTP:
      return {
        ...state,
        testGenerateOTPIsError: false,
        testGenerateOTPLoading: true,
        otpServiceIsError: false
      };

    case actions.TEST_GENERATE_OTP_SUCCESS:
      return {
        ...state,
        testGenerateOTPLoading: action.loading,
        errorMessage: action.message,
        testGenerateOTPIsError: false,
        testGenerateOTPData: action.result,
        otpServiceIsError: false
      };

    case actions.TEST_GENERATE_OTP_FAILED:
      return {
        ...state,
        testGenerateOTPLoading: action.loading,
        errorMessage: action.message,
        otpServiceIsError: true,
        testGenerateOTPData: action.result
      };

    case actions.RESET_TEST_GENERATE_OTP:
      return {
        ...state,
        testGenerateOTPData: null
      };

    case actions.ADDING_PROVINCE_DATA:
      return {
        ...state,
        addressLoading: true,
        isError: false,
        pageLoading: true
      };

    case actions.ADD_PROVINCE_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        addressLoading: action.loading,
        isError: false,
        pageLoading: false
      };

    case actions.ADD_PROVINCE_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        addressLoading: action.loading,
        isError: true,
        pageLoading: false
      };

    case actions.DEFINING_KEY_CITIES:
      return {
        ...state,
        isError: false,
        addressLoading: action.loading,
        pageLoading: action.loading
      };

    case actions.DEFINE_KEY_CITIES_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        addressLoading: action.loading,
        pageLoading: action.loading
      };

    case actions.DEFINE_KEY_CITIES_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        addressLoading: action.loading,
        pageLoading: action.loading
      };

    case actions.DELETING_LOOKUP_DATA:
      return {
        ...state,
        lookupsLoading: true,
        isError: false,
        pageLoading: true
      };

    case actions.DELETE_LOOKUP_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        lookupsLoading: false,
        pageLoading: false
      };

    case actions.DELETE_LOOKUP_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        lookupsLoading: false,
        pageLoading: false
      };

    case actions.EDITING_ADDRESS_DATA:
      return {
        ...state,
        isError: false,
        addressLoading: true,
        pageLoading: action.loading
      };

    case actions.EDIT_ADDRESS_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        addressLoading: false,
        pageLoading: action.loading
      };

    case actions.EDIT_ADDRESS_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        addressLoading: false,
        pageLoading: action.loading
      };

    case actions.EDITING_OTP_SETTINGS_DATA:
      return {
        ...state,
        otpServiceIsError: false,
        otpServiceLoading: true
      };

    case actions.EDIT_OTP_SETTINGS_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        otpServiceIsError: false,
        otpServiceLoading: false
      };

    case actions.EDIT_OTP_SETTINGS_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        otpServiceIsError: true,
        otpServiceLoading: false
      };

    case actions.EDITING_OTP_SETTINGS_TEMPLATE_DATA:
      return {
        ...state,
        otpServiceTemplateIsError: false,
        otpServiceTemplateLoading: true
      };

    case actions.EDIT_OTP_SETTINGS_TEMPLATE_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        otpServiceTemplateIsError: false,
        otpServiceTemplateLoading: false
      };

    case actions.EDIT_OTP_SETTINGS_TEMPLATE_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        otpServiceTemplateIsError: true,
        otpServiceTemplateLoading: false
      };

    case actions.GENERATING_NEW_OTP_KEY_DATA:
      return {
        ...state,
        otpServiceIsError: false,
        otpServiceLoading: true
      };

    case actions.GENERATE_NEW_OTP_KEY_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        otpServiceIsError: false,
        otpServiceLoading: false
      };

    case actions.GENERATE_NEW_OTP_KEY_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        otpServiceIsError: true,
        otpServiceLoading: false
      };

    case actions.CHANGING_STATUS_ADDRESS_DATA:
      return {
        ...state,
        addressLoading: true,
        pageLoading: true,
        isError: false
      };

    case actions.CHANGE_STATUS_ADDRESS_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        addressLoading: false,
        pageLoading: false
      };

    case actions.CHANGE_STATUS_ADDRESS_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        addressLoading: false,
        pageLoading: false
      };

    case actions.CHANGING_STATUS_INDUSTRY_DATA:
      return {
        ...state,
        industryLoading: true,
        isError: false,
        pageLoading: true
      };

    case actions.CHANGE_STATUS_INDUSTRY_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        industryLoading: false,
        pageLoading: false
      };

    case actions.CHANGE_STATUS_INDUSTRY_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        industryLoading: false,
        pageLoading: false
      };

    case actions.DELETING_ROLE_DATA:
      return {
        ...state,
        roleLoading: true,
        isError: false,
        pageLoading: true
      };

    case actions.DELETE_ROLE_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        roleLoading: false,
        pageLoading: false,
        activeRole: null
      };

    case actions.DELETE_ROLE_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        roleLoading: false,
        pageLoading: false
      };

    case actions.DELETING_USER_DATA:
      return {
        ...state,
        isError: false,
        userLoading: true,
        pageLoading: true
      };

    case actions.DELETE_USER_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        userLoading: false,
        pageLoading: false
      };

    case actions.DELETE_USER_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true
      };

    case actions.EDITING_USER_DATA:
      return {
        ...state,
        isError: false,
        btnLoading: true
      };

    case actions.EDIT_USER_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        userData: null,
        btnLoading: false
      };

    case actions.EDIT_USER_DATA_FAILED:
      return {
        ...state,
        isError: true,
        errorMessage: action.message,
        btnLoading: false
      };

    case actions.RESETTING_USER_PASSWORD:
      return {
        ...state,
        pageLoading: action.loading,
        userLoading: true,
        isError: false,
        btnLoading: true
      };

    case actions.RESET_USER_PASSWORD_SUCCESS:
      return {
        ...state,
        userLoading: false,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        btnLoading: false
      };

    case actions.RESET_USER_PASSWORD_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: action.loading,
        isError: true,
        userLoading: false,
        btnLoading: false
      };

    case actions.UNLOCKING_USER:
      return {
        ...state,
        btnLoading: true,
        isError: false
      };

    case actions.UNLOCK_USER_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        userData: null,
        btnLoading: false,
        isError: false
      };

    case actions.UNLOCK_USER_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        btnLoading: false
      };

    case actions.CHANGING_USER_STATUS:
      return {
        ...state,
        btnLoading: true,
        isError: false
      };

    case actions.CHANGE_USER_STATUS_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        userData: null,
        btnLoading: false,
        isError: false
      };

    case actions.CHANGE_USER_STATUS_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        btnLoading: false
      };

    case actions.RESET_LOOKUPS_DATA:
      return {
        ...state,
        lookupsData: null,
        newLookupsData: null
      };

    case actions.FETCHING_MODULE_DATA:
      return {
        ...state,
        moduleData: null,
        pageLoading: action.loading,
        moduleLoading: action.loading
      };

    case actions.FETCH_MODULE_DATA_SUCCESS:
      return {
        ...state,
        moduleLoading: action.loading,
        pageLoading: action.loading,
        moduleData: action.result,
        isError: false
      };

    case actions.FETCH_MODULE_DATA_FAILED:
      return {
        ...state,
        moduleLoading: action.loading,
        pageLoading: action.loading,
        moduleData: null,
        isError: true
      };

    case actions.ADDING_MODULE_DATA:
      return {
        ...state,
        isError: false,
        moduleLoading: true,
        pageLoading: true
      };

    case actions.ADD_MODULE_DATA_SUCCESS:
      return {
        ...state,
        moduleLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.ADD_MODULE_DATA_FAILED:
      return {
        ...state,
        moduleLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.FETCHING_PCHANNEL_DATA:
      return {
        ...state,
        paymentChannel: null,
        pageLoading: action.loading,
        paymentChannelLoading: action.loading
      };

    case actions.FETCH_PCHANNEL_DATA_SUCCESS:
      return {
        ...state,
        paymentChannelLoading: action.loading,
        pageLoading: action.loading,
        paymentChannel: action.result,
        paymentChannelIsError: false
      };

    case actions.FETCH_PCHANNEL_DATA_FAILED:
      return {
        ...state,
        paymentChannelLoading: action.loading,
        pageLoading: action.loading,
        paymentChannel: action.result,
        paymentChannelIsError: true
      };

    case actions.FETCHING_NOTIFICATION_DATA:
      return {
        ...state,
        notificationData: null,
        pageLoading: action.loading,
        notificationLoading: action.loading
      };

    case actions.FETCH_NOTIFICATION_DATA_SUCCESS:
      return {
        ...state,
        notificationLoading: action.loading,
        pageLoading: action.loading,
        notificationData: action.result,
        notificationIsError: false
      };

    case actions.FETCH_NOTIFICATION_DATA_FAILED:
      return {
        ...state,
        notificationLoading: action.loading,
        pageLoading: action.loading,
        notificationData: action.result,
        notificationIsError: true
      };
    case actions.ADDING_NOTIFICATION_DATA:
      return {
        ...state,
        notificationIsError: false,
        notificationLoading: true,
        pageLoading: true
      };

    case actions.ADD_NOTIFICATION_DATA_SUCCESS:
      return {
        ...state,
        notificationLoading: action.loading,
        errorMessage: action.message,
        notificationIsError: false,
        pageLoading: false
      };

    case actions.ADD_NOTIFICATION_DATA_FAILED:
      return {
        ...state,
        notificationLoading: action.loading,
        errorMessage: action.message,
        notificationIsError: true,
        pageLoading: false
      };

    case actions.UPDATING_APP_NOTIFICATION:
      return {
        ...state,
        isErrorAppSettings: false,
        appSettingsLoading: true
      };

    case actions.UPDATE_APP_NOTIFICATION_SUCCESS:
      return {
        ...state,
        appSettingsLoading: action.loading,
        appSettingsErrorMessage: action.message,
        isErrorAppSettings: false
      };

    case actions.UPDATE_APP_NOTIFICATION_FAILED:
      return {
        ...state,
        appSettingsErrorMessage: action.message,
        appSettingsLoading: action.loading,
        isErrorAppSettings: true
      };

    case actions.RESET_UPDATE_APP_NOTIFICATION:
      return {
        ...state,
        appSettingsLoading: false,
        isErrorAppSettings: false,
        appSettingsErrorMessage: null
      };

    case actions.GETTING_USER_LIST_BY_ROLE:
      return {
        ...state,
        userListByRoleID: null,
        userListByRoleIDLoading: action.loading
      };

    case actions.GET_USER_LIST_BY_ROLE_SUCCESS:
      return {
        ...state,
        userListByRoleIDLoading: action.loading,
        userListByRoleID: action.result,
        userListByRoleIDIsError: false
      };

    case actions.GET_USER_LIST_BY_ROLE_FAILED:
      return {
        ...state,
        userListByRoleIDLoading: action.loading,
        userListByRoleID: action.result,
        userListByRoleIDIsError: true
      };

    case actions.FETCHING_USERS:
      return {
        ...state,
        users: null,
        usersLoading: action.loading
      };

    case actions.FETCH_USERS_SUCCESS:
      return {
        ...state,
        usersLoading: action.loading,
        users: action.result,
        usersIsError: false
      };

    case actions.FETCH_USERS_FAILED:
      return {
        ...state,
        usersLoading: action.loading,
        users: action.result,
        usersIsError: true
      };

    case actions.REORDERING_LOOKUP_DATA:
      return {
        ...state,
        isError: false,
        lookupsLoading: true,
        pageLoading: true
      };

    case actions.REORDER_LOOKUP_DATA_SUCCESS:
      return {
        ...state,
        lookupsLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.REORDER_LOOKUP_DATA_FAILED:
      return {
        ...state,
        lookupsLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.REORDERING_PAGE_DATA:
      return {
        ...state,
        isError: false,
        pageLoading: true
      };

    case actions.REORDER_PAGE_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.REORDER_PAGE_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };
    case actions.FETCHING_EXTERNAL_RECIPIENTS_DATA:
      return {
        ...state,
        externalRecipientData: null,
        externalRecipientLoading: action.loading
      };

    case actions.FETCH_EXTERNAL_RECIPIENTS_DATA_SUCCESS:
      return {
        ...state,
        externalRecipientData: action.result,
        externalRecipientLoading: action.loading,
        externalRecipientIsError: false
      };

    case actions.FETCH_EXTERNAL_RECIPIENTS_DATA_FAILED:
      return {
        ...state,
        externalRecipientLoading: action.loading,
        externalRecipientData: null,
        externalRecipientIsError: true
      };
    case actions.REORDERING_MODULE_DATA:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        moduleLoading: true
      };

    case actions.REORDER_MODULE_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: false,
        moduleLoading: false
      };

    case actions.REORDER_MODULE_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false,
        moduleLoading: false
      };

    case actions.EDITING_EXTERNAL_RECIPIENT_DATA:
      return {
        ...state,
        externalRecipientIsError: false,
        externalRecipientLoading: true,
        pageLoading: action.loading
      };

    case actions.EDIT_EXTERNAL_RECIPIENT_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        externalRecipientIsError: false,
        externalRecipientLoading: false,
        pageLoading: action.loading
      };

    case actions.EDIT_EXTERNAL_RECIPIENT_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        externalRecipientIsError: true,
        externalRecipientLoading: false,
        pageLoading: action.loading
      };
    case actions.FETCHING_LOOKUP_VALIDATION_DATA:
      return {
        ...state,
        lookupValidationData: null,
        pageLoading: action.loading,
        lookupValidationLoading: action.loading
      };

    case actions.FETCH_LOOKUP_VALIDATION_DATA_SUCCESS:
      return {
        ...state,
        lookupValidationLoading: action.loading,
        pageLoading: action.loading,
        lookupValidationData: action.result,
        lookupValidationIsError: false
      };

    case actions.FETCH_LOOKUP_VALIDATION_DATA_FAILED:
      return {
        ...state,
        lookupValidationLoading: action.loading,
        pageLoading: action.loading,
        lookupValidationData: action.result,
        lookupValidationIsError: true
      };

    case actions.SETTING_LOOKUP_VALIDATION_DATA:
      return {
        ...state,
        lookupValidationIsError: false,
        lookupValidationLoading: true,
        pageLoading: action.loading
      };

    case actions.SET_LOOKUP_VALIDATION_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        lookupValidationIsError: false,
        lookupValidationLoading: false,
        pageLoading: action.loading
      };

    case actions.SET_LOOKUP_VALIDATION_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        lookupValidationIsError: true,
        lookupValidationLoading: false,
        pageLoading: action.loading
      };

    case actions.EDITING_LOOKUP_VALIDATION_DATA:
      return {
        ...state,
        lookupValidationIsError: false,
        lookupValidationLoading: true,
        pageLoading: action.loading
      };

    case actions.EDIT_LOOKUP_VALIDATION_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        lookupValidationIsError: false,
        lookupValidationLoading: false,
        pageLoading: action.loading
      };

    case actions.EDIT_LOOKUP_VALIDATION_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        lookupValidationIsError: true,
        lookupValidationLoading: false,
        pageLoading: action.loading
      };
    case actions.DELETING_LOOKUP_VALIDATION_DATA:
      return {
        ...state,
        lookupValidationLoading: true,
        lookupValidationIsError: false,
        pageLoading: true
      };

    case actions.DELETE_LOOKUP_VALIDATION_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        lookupValidationIsError: false,
        lookupValidationLoading: false,
        pageLoading: false
      };

    case actions.DELETE_LOOKUP_VALIDATION_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        lookupValidationIsError: true,
        lookupValidationLoading: false,
        pageLoading: false
      };

    case actions.FETCHING_PAYMENT_CHANNEL_LIST_DATA:
      return {
        ...state,
        paymentChannelListData: null,
        paymentChannelListLoading: action.loading
      };

    case actions.FETCH_PAYMENT_CHANNEL_LIST_DATA_SUCCESS:
      return {
        ...state,
        paymentChannelListLoading: action.loading,
        paymentChannelListData: action.result,
        paymentChannelListIsError: false
      };

    case actions.FETCH_PAYMENT_CHANNEL_LIST_DATA_FAILED:
      return {
        ...state,
        paymentChannelListLoading: action.loading,
        paymentChannelListData: action.result,
        paymentChannelListIsError: true
      };

    case actions.FETCHING_PAYMENT_METHOD_LIST_DATA:
      return {
        ...state,
        paymentMethodListData: null,
        paymentMethodListLoading: action.loading
      };

    case actions.FETCH_PAYMENT_METHOD_LIST_DATA_SUCCESS:
      return {
        ...state,
        paymentMethodListLoading: action.loading,
        paymentMethodListData: action.result,
        paymentMethodListIsError: false
      };

    case actions.FETCH_PAYMENT_METHOD_LIST_DATA_FAILED:
      return {
        ...state,
        paymentMethodListLoading: action.loading,
        paymentMethodListData: action.result,
        paymentMethodListIsError: true
      };

    case actions.FETCHING_TEMPLATE_DATA:
      return {
        ...state,
        templateData: null,
        pageLoading: action.loading,
        templateDataLoading: action.loading
      };

    case actions.FETCH_TEMPLATE_DATA_SUCCESS:
      return {
        ...state,
        templateDataLoading: action.loading,
        pageLoading: action.loading,
        templateData: action.result,
        templateDataIsError: false
      };

    case actions.FETCH_TEMPLATE_DATA_FAILED:
      return {
        ...state,
        templateDataLoading: action.loading,
        pageLoading: action.loading,
        templateData: action.result,
        templateDataIsError: true
      };

    case actions.RESET_TEMPLATE_DATA:
      return {
        ...state,
        templateDataLoading: false,
        pageLoading: false,
        templateData: null,
        templateDataIsError: false
      };
    case actions.FETCHING_BANK_TEMPLATE_DATA:
      return {
        ...state,
        bankTemplateData: null,
        pageLoading: action.loading,
        bankTemplateDataLoading: action.loading
      };

    case actions.FETCH_BANK_TEMPLATE_DATA_SUCCESS:
      return {
        ...state,
        bankTemplateDataLoading: action.loading,
        pageLoading: action.loading,
        bankTemplateData: action.result,
        bankTemplateDataIsError: false
      };

    case actions.FETCH_BANK_TEMPLATE_DATA_FAILED:
      return {
        ...state,
        bankTemplateDataLoading: action.loading,
        pageLoading: action.loading,
        bankTemplateData: action.result,
        bankTemplateDataIsError: true
      };

    case actions.ADDING_TEMPLATE_DATA:
      return {
        ...state,
        templateDataIsError: false,
        templateDataLoading: true,
        pageLoading: true
      };

    case actions.ADD_TEMPLATE_DATA_SUCCESS:
      return {
        ...state,
        templateDataLoading: action.loading,
        errorMessage: action.message,
        templateDataIsError: false,
        pageLoading: false
      };

    case actions.ADD_TEMPLATE_DATA_FAILED:
      return {
        ...state,
        templateDataLoading: action.loading,
        errorMessage: action.message,
        templateDataIsError: true,
        pageLoading: false
      };

    case actions.ADDING_BANK_TEMPLATE_DATA:
      return {
        ...state,
        bankTemplateDataIsError: false,
        bankTemplateDataLoading: true,
        pageLoading: true
      };

    case actions.ADD_BANK_TEMPLATE_DATA_SUCCESS:
      return {
        ...state,
        bankTemplateDataLoading: action.loading,
        errorMessage: action.message,
        bankTemplateDataIsError: false,
        pageLoading: false
      };

    case actions.ADD_BANK_TEMPLATE_DATA_FAILED:
      return {
        ...state,
        bankTemplateDataLoading: action.loading,
        errorMessage: action.message,
        bankTemplateDataIsError: true,
        pageLoading: false
      };

    case actions.EDITING_TEMPLATE_DATA:
      return {
        ...state,
        templateDataisError: false,
        templateDataLoading: true,
        pageLoading: action.loading
      };

    case actions.EDIT_TEMPLATE_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        templateDataisError: false,
        templateDataLoading: false,
        pageLoading: action.loading
      };

    case actions.EDIT_TEMPLATE_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        templateDataisError: true,
        templateDataLoading: false,
        pageLoading: action.loading
      };

    case actions.FETCHING_UPLOADED_FILES:
      return {
        ...state,
        uploadedFiles: null,
        pageLoading: action.loading,
        uploadedFilesLoading: action.loading
      };

    case actions.FETCH_UPLOADED_FILES_SUCCESS:
      return {
        ...state,
        uploadedFilesLoading: action.loading,
        pageLoading: action.loading,
        uploadedFiles: action.result,
        uploadedChannel: action.channel,
        uploadedFilesIsError: false,
        uploadedFilesPagination: action.pagination
      };

    case actions.FETCH_UPLOADED_FILES_FAILED:
      return {
        ...state,
        uploadedFilesLoading: action.loading,
        pageLoading: action.loading,
        uploadedFiles: action.result,
        uploadedChannel: action.channel,
        uploadedFilesIsError: true,
        uploadedFilesPagination: action.pagination
      };

    case actions.UPLOADING_FILE_TRANSACTION_DATA:
      return {
        ...state,
        isFileError: false,
        fileLoading: true,
        pageLoading: true
      };

    case actions.UPLOADING_MULTIPLE_FILE_TRANSACTION_DATA:
      return {
        ...state,
        fileLoading: true,
        isFileError: false,
        pageLoading: true
      };

    case actions.UPLOAD_FILE_TRANSACTION_DATA_SUCCESS:
      return {
        ...state,
        fileLoading: action.loading,
        errorMessage: action.message,
        isFileError: false,
        pageLoading: false
      };

    case actions.UPLOAD_FILE_TRANSACTION_DATA_FAILED:
      return {
        ...state,
        fileLoading: action.loading,
        errorMessage: action.message,
        isFileError: true,
        pageLoading: false
      };

    case actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_FAILED:
      return {
        ...state,
        fileLoading: action.loading,
        isFileError: true,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_SUCCESS:
      return {
        ...state,
        fileLoading: action.loading,
        isFileError: false,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.UPLOADING_LEADS_FILE_DATA:
      return {
        ...state,
        fileLoading: true,
        isFileError: false,
        pageLoading: true
      };

    case actions.UPLOAD_LEADS_FILE_DATA_FAILED:
      return {
        ...state,
        fileLoading: action.loading,
        isFileError: true,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.UPLOAD_LEADS_FILE_DATA_SUCCESS:
      return {
        ...state,
        // fileLoading: action.loading,
        isFileError: false,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.DONE_PARSING_LEADS_FILE_DATA:
      return {
        ...state,
        fileLoading: false
      };

    case actions.REUPLOADING_LEADS_FILE_DATA:
      return {
        ...state,
        fileLoading: true,
        isFileError: false,
        pageLoading: true
      };

    case actions.REUPLOAD_LEADS_FILE_DATA_FAILED:
      return {
        ...state,
        fileLoading: action.loading,
        isFileError: true,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.REUPLOAD_LEADS_FILE_DATA_SUCCESS:
      return {
        ...state,
        // fileLoading: action.loading,
        isFileError: false,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.REUPLOADING_FILE_TRANSACTION_DATA:
      return {
        ...state,
        isFileError: false,
        fileLoading: true,
        pageLoading: true
      };

    case actions.REUPLOAD_FILE_TRANSACTION_DATA_SUCCESS:
      return {
        ...state,
        fileLoading: action.loading,
        errorMessage: action.message,
        isFileError: false,
        pageLoading: false
      };

    case actions.REUPLOAD_FILE_TRANSACTION_DATA_FAILED:
      return {
        ...state,
        fileLoading: action.loading,
        errorMessage: action.message,
        isFileError: true,
        pageLoading: false
      };

    case actions.GETTING_PRE_SIGNED_URL:
      return {
        ...state,
        preSignedURL: null,
        pageLoading: action.loading,
        preSignedURLLoading: action.loading
      };

    case actions.GET_PRE_SIGNED_URL_SUCCESS:
      return {
        ...state,
        preSignedURLLoading: action.loading,
        pageLoading: action.loading,
        preSignedURL: action.result,
        preSignedURLIsError: false
      };

    case actions.FETCHING_COSMOS_LOGS:
      return {
        ...state,
        cosmosLogs: null,
        cosmosLogsLoading: action.loading
      };

    case actions.FETCH_COSMOS_LOGS_SUCCESS:
      return {
        ...state,
        cosmosLogsLoading: action.loading,
        cosmosLogs: action.result,
        cosmosLogsPagination: action.pagination,
        cosmosLogsIsError: false,
        cosmosLogsFilter: action.filter
      };

    case actions.FETCH_COSMOS_LOGS_FAILED:
      return {
        ...state,
        cosmosLogsLoading: action.loading,
        cosmosLogs: action.result,
        cosmosLogsPagination: action.pagination,
        cosmosLogsIsError: true,
        cosmosLogsFilter: action.filter
      };

    case actions.GET_PRE_SIGNED_URL_FAILED:
      return {
        ...state,
        preSignedURLLoading: action.loading,
        pageLoading: action.loading,
        preSignedURL: action.result,
        preSignedURLIsError: true
      };

    case actions.GETTING_PRE_SIGNED_URL_WITH_KEY:
      return {
        ...state,
        preSignedURL: null,
        pageLoading: action.loading,
        preSignedURLLoading: action.loading
      };

    case actions.GET_PRE_SIGNED_URL_WITH_KEY_SUCCESS:
      return {
        ...state,
        preSignedURLLoading: action.loading,
        pageLoading: action.loading,
        preSignedURL: action.result,
        preSignedURLIsError: false
      };

    case actions.GET_PRE_SIGNED_URL_WITH_KEY_FAILED:
      return {
        ...state,
        preSignedURLLoading: action.loading,
        pageLoading: action.loading,
        preSignedURL: action.result,
        preSignedURLIsError: true
      };

    case actions.UPLOADING_BANK_TRX_DATA:
      return {
        ...state,
        bankFileUploadIsError: false,
        bankFileUploadLoading: true
      };

    case actions.UPLOAD_BANK_TRX_DATA_SUCCESS:
      return {
        ...state,
        bankFileUploadLoading: action.loading,
        errorMessage: action.message,
        bankFileUploadIsError: false
      };

    case actions.UPLOAD_BANK_TRX_DATA_FAILED:
      return {
        ...state,
        bankFileUploadLoading: action.loading,
        errorMessage: action.message,
        bankFileUploadIsError: true
      };

    case actions.SET_PAYMENT_CHANNEL_FILTER:
      return {
        ...state,
        paymentChannelFilter: action.payload
      };

    case actions.GETTING_LIST_OF_PRE_SIGNED_URL:
      return {
        ...state,
        pageLoading: action.loading,
        presignedListLoading: action.loading
      };

    case actions.GET_LIST_OF_PRE_SIGNED_URL_SUCCESS:
      return {
        ...state,
        presignedListLoading: action.loading,
        pageLoading: action.loading,
        presignedListURLs: action.result,
        presignedListIsError: false
      };

    case actions.GET_LIST_OF_PRE_SIGNED_URL_FAILED:
      return {
        ...state,
        presignedListLoading: action.loading,
        pageLoading: action.loading,
        presignedListURLs: action.result,
        presignedListIsError: true
      };

    case actions.FETCHING_SYSTEM_SETTINGS:
      return {
        ...state,
        systemSettings: null,
        systemSettingsLoading: action.loading
      };

    case actions.FETCH_SYSTEM_SETTINGS_SUCCESS:
      return {
        ...state,
        systemSettingsLoading: action.loading,
        systemSettings: action.result,
        systemSettingsIsError: false
      };

    case actions.FETCH_SYSTEM_SETTINGS_FAILED:
      return {
        ...state,
        systemSettingsLoading: action.loading,
        systemSettings: action.result,
        systemSettingsIsError: true
      };

    case actions.ADDING_SYSTEM_SETTINGS:
      return {
        ...state,
        isError: false,
        systemSettingsLoading: action.loading,
        pageLoading: action.loading
      };

    case actions.ADD_SYSTEM_SETTINGS_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        systemSettingsLoading: action.loading
      };

    case actions.ADD_SYSTEM_SETTINGS_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        systemSettingsLoading: action.loading
      };

    case actions.EDITING_SYSTEM_SETTINGS:
      return {
        ...state,
        isError: false,
        systemSettingsLoading: action.loading
      };

    case actions.EDIT_SYSTEM_SETTINGS_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading
      };

    case actions.EDIT_SYSTEM_SETTINGS_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.FETCHING_PAYNAMICS_BANK_DATA:
      return {
        ...state,
        paynamicsBanks: null,
        paynamicsBanksLoading: action.loading
      };

    case actions.FETCH_PAYNAMICS_BANK_DATA_SUCCESS:
      return {
        ...state,
        paynamicsBanksLoading: action.loading,
        pageLoading: action.loading,
        paynamicsBanks: action.result,
        paynamicsBanksIsError: false
      };

    case actions.FETCH_PAYNAMICS_BANK_DATA_FAILED:
      return {
        ...state,
        paynamicsBanksLoading: action.loading,
        pageLoading: action.loading,
        paynamicsBanks: action.result,
        paynamicsBanksIsError: true
      };

    case actions.RESET_PAYNAMICS_BANK_DATA:
      return {
        ...state,
        paynamicsBanks: null
      };

    case actions.ADDING_PAYNAMICS_BANK:
      return {
        ...state,
        addPaynamicsBanksIsError: false,
        addPaynamicsBankLoading: true
      };

    case actions.ADD_PAYNAMICS_BANK_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        addPaynamicsBanksIsError: false,
        addPaynamicsBankLoading: false
      };

    case actions.ADD_PAYNAMICS_BANK_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        addPaynamicsBanksIsError: true,
        addPaynamicsBankLoading: false
      };

    case actions.EDITING_PAYNAMICS_BANK:
      return {
        ...state,
        editPaynamicsBanksIsError: false,
        editPaynamicsBankLoading: true
      };

    case actions.EDIT_PAYNAMICS_BANK_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        editPaynamicsBanksIsError: false,
        editPaynamicsBankLoading: false
      };

    case actions.EDIT_PAYNAMICS_BANK_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        editPaynamicsBanksIsError: true,
        editPaynamicsBankLoading: false
      };

    case actions.EDITING_PAYNAMICS_BANK_TEMPLATE_DATA:
      return {
        ...state,
        bankTemplateDataIsError: false,
        bankTemplateDataLoading: true
      };

    case actions.EDIT_PAYNAMICS_BANK_TEMPLATE_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        bankTemplateDataIsError: false,
        bankTemplateDataLoading: false
      };

    case actions.EDIT_PAYNAMICS_BANK_TEMPLATE_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        bankTemplateDataIsError: true,
        bankTemplateDataLoading: false
      };

    case (actions.ADDING_PAGE_ACTION, actions.EDITING_PAGE_ACTION):
      return {
        ...state,
        pageActionIsError: false,
        pageActionLoading: true,
        pageLoading: true
      };

    case (actions.ADD_PAGE_ACTION_SUCCESS, actions.EDIT_PAGE_ACTION_SUCCESS):
      return {
        ...state,
        pageActionLoading: action.loading,
        errorMessage: action.message,
        pageActionIsError: false,
        pageLoading: false
      };

    case (actions.ADD_PAGE_ACTION_FAILED, actions.EDIT_PAGE_ACTION_FAILED):
      return {
        ...state,
        pageActionLoading: action.loading,
        errorMessage: action.message,
        pageActionIsError: true,
        pageLoading: false
      };

    case actions.FETCHING_USER_SYSTEM_LOGS:
      return {
        ...state,
        userActivityLoading: action.loading
      };

    case actions.FETCH_USER_SYSTEM_LOGS_SUCCESS:
      return {
        ...state,
        userActivityLoading: action.loading,
        userActivityData: action.result,
        userActivityIsError: false,
        userActivityPagination: action.pagination,
        userActivityLoadMore: false,
        userActivityFilter: action.filter
      };

    case actions.LOADING_MORE_USER_SYSTEM_LOGS:
      return {
        ...state,
        userActivityLoadMore: true
      };

    case actions.FETCH_USER_SYSTEM_LOGS_FAILED:
      return {
        ...state,
        userActivityLoading: action.loading,
        userActivityIsError: true,
        userActivityLoadMore: false,
        userActivityData: action.payload
      };
    case actions.RESET_USER_SYSTEM_LOGS:
      return {
        ...state,
        userActivityIsError: false,
        userActivityData: null,
        userActivityFilter: null
      };

    case actions.FETCHING_LOGS_BY_ITEM_ID:
      return {
        ...state,
        currentItemLogsIsLoading: action.loading,
        currentItemLogsIsError: false
      };

    case actions.FETCH_LOGS_BY_ITEM_ID_SUCCESS:
      return {
        ...state,
        currentItemLogs: action.result,
        currentItemLogsIsLoading: action.loading,
        currentItemLogsIsError: false,
        currentItemLogPagination: action.pagination
      };

    case actions.FETCH_LOGS_BY_ITEM_ID_FAILED:
      return {
        ...state,
        currentItemLogsIsLoading: action.loading,
        currentItemLogsIsError: true
      };

    case actions.RESET_MODULE_DATA:
      return {
        ...state,
        moduleData: null
      };

    case actions.ADDING_PAYMENT_CHANNEL_DATA:
      return {
        ...state,
        isError: false,
        paymentChannelLoading: true,
        pageLoading: true
      };

    case actions.ADD_PAYMENT_CHANNEL_DATA_SUCCESS:
      return {
        ...state,
        paymentChannelLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.ADD_PAYMENT_CHANNEL_DATA_FAILED:
      return {
        ...state,
        paymentChannelLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.EDITING_PAYMENT_CHANNEL_DATA:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading,
        paymentChannelLoading: action.loading
      };

    case actions.EDIT_PAYMENT_CHANNEL_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        paymentChannelLoading: action.loading
      };

    case actions.EDIT_PAYMENT_CHANNEL_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading,
        paymentChannelLoading: action.loading
      };

    case actions.EDITING_NOTIFICATION_SETTING:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.EDIT_NOTIFICATION_SETTING_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading
      };

    case actions.EDIT_NOTIFICATION_SETTING_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.ADDING_PAYMENT_CHANNEL_PAYLOAD:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.ADD_PAYMENT_CHANNEL_PAYLOAD_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        paymentChannelPayloadById: action.result
      };

    case actions.ADD_PAYMENT_CHANNEL_PAYLOAD_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.FETCHING_PAYMENT_CHANNEL_PAYLOAD_BY_ID:
      return {
        ...state,
        paymentChannelPayloadByIdLoading: action.loading
      };

    case actions.FETCH_PAYMENT_CHANNEL_PAYLOAD_BY_ID_SUCCESS:
      return {
        ...state,
        paymentChannelPayloadByIdLoading: action.loading,
        paymentChannelPayloadById: action.result,
        paymentChannelPayloadByIdHasError: false
      };

    case actions.FETCH_PAYMENT_CHANNEL_PAYLOAD_BY_ID_FAILED:
      return {
        ...state,
        paymentChannelPayloadByIdLoading: action.loading,
        paymentChannelPayloadById: null,
        paymentChannelPayloadByIdHasError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.RESET_PAYMENT_CHANNEL_PAYLOAD_BY_ID:
      return {
        ...state,
        paymentChannelPayloadByIdLoading: false,
        paymentChannelPayloadByIdHasError: false,
        paymentChannelPayloadById: null
      };

    case actions.UPDATING_PAYMENT_CHANNEL_PAYLOAD:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.UPDATE_PAYMENT_CHANNEL_PAYLOAD_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        paymentChannelPayloadById: action.result
      };

    case actions.UPDATE_PAYMENT_CHANNEL_PAYLOAD_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.ADDING_INSTALLMENT_MODE_PAYLOAD:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.ADD_INSTALLMENT_MODE_PAYLOAD_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        installmentModePayloadById: action.result
      };

    case actions.ADD_INSTALLMENT_MODE_PAYLOAD_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.FETCHING_INSTALLMENT_MODE_PAYLOAD_BY_ID:
      return {
        ...state,
        installmentModePayloadByIdLoading: action.loading
      };

    case actions.FETCH_INSTALLMENT_MODE_PAYLOAD_BY_ID_SUCCESS:
      return {
        ...state,
        installmentModePayloadByIdLoading: action.loading,
        installmentModePayloadById: action.result,
        installmentModePayloadByIdHasError: false
      };

    case actions.FETCH_INSTALLMENT_MODE_PAYLOAD_BY_ID_FAILED:
      return {
        ...state,
        installmentModePayloadByIdLoading: action.loading,
        installmentModePayloadById: null,
        installmentModePayloadByIdHasError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.RESET_INSTALLMENT_MODE_PAYLOAD_BY_ID:
      return {
        ...state,
        installmentModePayloadByIdLoading: false,
        installmentModePayloadByIdHasError: false,
        installmentModePayloadById: null
      };

    case actions.UPDATING_INSTALLMENT_MODE_PAYLOAD:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.UPDATE_INSTALLMENT_MODE_PAYLOAD_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        installmentModePayloadById: action.result
      };

    case actions.UPDATE_INSTALLMENT_MODE_PAYLOAD_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.ADDING_INSTALLMENT_TENOR_PAYLOAD:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.ADD_INSTALLMENT_TENOR_PAYLOAD_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        installmentModePayloadById: action.result
      };

    case actions.ADD_INSTALLMENT_TENOR_PAYLOAD_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.UPDATING_INSTALLMENT_TENOR_PAYLOAD:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.UPDATE_INSTALLMENT_TENOR_PAYLOAD_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        installmentModePayloadById: action.result
      };

    case actions.UPDATE_INSTALLMENT_TENOR_PAYLOAD_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.ADDING_SUB_CHANNEL_PAYLOAD:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.ADD_SUB_CHANNEL_PAYLOAD_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        subChannelPayloadById: action.result
      };

    case actions.ADD_SUB_CHANNEL_PAYLOAD_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.FETCHING_SUB_CHANNEL_PAYLOAD_BY_ID:
      return {
        ...state,
        subChannelPayloadByIdLoading: action.loading
      };

    case actions.FETCH_SUB_CHANNEL_PAYLOAD_BY_ID_SUCCESS:
      return {
        ...state,
        subChannelPayloadByIdLoading: action.loading,
        subChannelPayloadById: action.result,
        subChannelPayloadByIdHasError: false
      };

    case actions.FETCH_SUB_CHANNEL_PAYLOAD_BY_ID_FAILED:
      return {
        ...state,
        subChannelPayloadByIdLoading: action.loading,
        subChannelPayloadById: null,
        subChannelPayloadByIdHasError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.RESET_SUB_CHANNEL_PAYLOAD_BY_ID:
      return {
        ...state,
        subChannelPayloadByIdLoading: false,
        subChannelPayloadByIdHasError: false,
        subChannelPayloadById: null
      };

    case actions.UPDATING_SUB_CHANNEL_PAYLOAD:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.UPDATE_SUB_CHANNEL_PAYLOAD_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        subChannelPayloadById: action.result
      };

    case actions.UPDATE_SUB_CHANNEL_PAYLOAD_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.ADDING_PROCESSOR_PAYLOAD:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.ADD_PROCESSOR_PAYLOAD_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        subChannelPayloadById: action.result
      };

    case actions.ADD_PROCESSOR_PAYLOAD_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.UPDATING_PROCESSOR_PAYLOAD:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.UPDATE_PROCESSOR_PAYLOAD_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        subChannelPayloadById: action.result
      };

    case actions.UPDATE_PROCESSOR_PAYLOAD_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.ADDING_MERCHANT_SPECIFIC_PAYLOAD:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.ADD_MERCHANT_SPECIFIC_PAYLOAD_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        merchantSpecificPayloadById: action.result
      };

    case actions.ADD_MERCHANT_SPECIFIC_PAYLOAD_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.FETCHING_MERCHANT_SPECIFIC_PAYLOAD_BY_ID:
      return {
        ...state,
        merchantSpecificPayloadByIdLoading: action.loading
      };

    case actions.FETCH_MERCHANT_SPECIFIC_PAYLOAD_BY_ID_SUCCESS:
      return {
        ...state,
        merchantSpecificPayloadByIdLoading: action.loading,
        merchantSpecificPayloadById: action.result,
        merchantSpecificPayloadByIdHasError: false
      };

    case actions.FETCH_MERCHANT_SPECIFIC_PAYLOAD_BY_ID_FAILED:
      return {
        ...state,
        merchantSpecificPayloadByIdLoading: action.loading,
        merchantSpecificPayloadById: null,
        merchantSpecificPayloadByIdHasError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.RESET_MERCHANT_SPECIFIC_PAYLOAD_BY_ID:
      return {
        ...state,
        merchantSpecificPayloadByIdLoading: false,
        merchantSpecificPayloadByIdHasError: false,
        merchantSpecificPayloadById: null
      };

    case actions.UPDATING_MERCHANT_SPECIFIC_PAYLOAD:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.UPDATE_MERCHANT_SPECIFIC_PAYLOAD_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        merchantSpecificPayloadById: action.result
      };

    case actions.UPDATE_MERCHANT_SPECIFIC_PAYLOAD_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.FETCHING_MERCHANT_SPECIFIC_PAYLOADS:
      return {
        ...state,
        merchantSpecificPayloadsData: null,
        merchantSpecificPayloadsLoading: action.loading,
        pageLoading: action.loading
      };

    case actions.FETCH_MERCHANT_SPECIFIC_PAYLOADS_SUCCESS:
      return {
        ...state,
        merchantSpecificPayloadsData: action.result,
        merchantSpecificPayloadsLoading: action.loading,
        pageLoading: action.loading,
        isError: false,
        merchantSpecificPayloadsDataIsError: false
      };

    case actions.FETCH_MERCHANT_SPECIFIC_PAYLOADS_FAILED:
      return {
        ...state,
        merchantSpecificPayloadsData: action.result,
        merchantSpecificPayloadsLoading: action.loading,
        pageLoading: action.loading,
        isError: true,
        merchantSpecificPayloadsDataIsError: true
      };

    case actions.FETCHING_PAYMENT_CHANNEL_CONFIGURATIONS:
      return {
        ...state,
        paymentChannelConfigurationsData: null,
        paymentChannelConfigurationsLoading: action.loading,
        pageLoading: action.loading
      };

    case actions.FETCH_PAYMENT_CHANNEL_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        paymentChannelConfigurationsData: action.result,
        paymentChannelConfigurationsLoading: action.loading,
        pageLoading: action.loading,
        isError: false,
        paymentChannelConfigurationsDataIsError: false
      };

    case actions.FETCH_PAYMENT_CHANNEL_CONFIGURATIONS_FAILED:
      return {
        ...state,
        paymentChannelConfigurationsData: action.result,
        paymentChannelConfigurationsLoading: action.loading,
        pageLoading: action.loading,
        isError: true,
        paymentChannelConfigurationsDataIsError: true
      };

    case actions.ADDING_INTEGRATION_MANAGEMENT:
      return {
        ...state,
        isError: false,
        integrationManagementLoading: true,
        pageLoading: true
      };

    case actions.ADD_INTEGRATION_MANAGEMENT_SUCCESS:
      return {
        ...state,
        integrationManagementLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.ADD_INTEGRATION_MANAGEMENT_FAILED:
      return {
        ...state,
        integrationManagementLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.FETCHING_INTEGRATION_MANAGEMENT:
      return {
        ...state,
        integrationManagementLoading: action.loading
      };

    case actions.FETCH_INTEGRATION_MANAGEMENT_SUCCESS:
      return {
        ...state,
        integrationManagementLoading: action.loading,
        integrationManagementData: action.result,
        integrationManagementIsError: false,
        integrationManagementPagination: action.pagination,
        integrationManagementFilter: action.filter
      };

    case actions.FETCH_INTEGRATION_MANAGEMENT_FAILED:
      return {
        ...state,
        integrationManagementLoading: action.loading,
        integrationManagementIsError: true,
        integrationManagementData: action.payload
      };

    case actions.FETCHING_INTEGRATION_MANAGEMENT_BY_ID:
      return {
        ...state,
        integrationManagementByIdLoading: action.loading
      };

    case actions.FETCH_INTEGRATION_MANAGEMENT_BY_ID_SUCCESS:
      return {
        ...state,
        integrationManagementByIdLoading: action.loading,
        integrationManagementById: action.result,
        integrationManagementByIdHasError: false
      };

    case actions.FETCH_INTEGRATION_MANAGEMENT_BY_ID_FAILED:
      return {
        ...state,
        integrationManagementByIdLoading: action.loading,
        integrationManagementById: null,
        integrationManagementByIdHasError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.RESET_INTEGRATION_MANAGEMENT_BY_ID:
      return {
        ...state,
        integrationManagementByIdLoading: false,
        integrationManagementByIdHasError: false,
        integrationManagementById: null
      };

    case actions.GENERATING_NEW_API_KEY_DATA:
      return {
        ...state,
        integrationManagementByIdHasError: false,
        // integrationManagementByIdLoading: true,
        generateNewAPIKeyLoading: true
      };

    case actions.GENERATE_NEW_API_KEY_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        integrationManagementByIdHasError: false,
        integrationManagementById: action.result,
        integrationManagementByIdLoading: false,
        generateNewAPIKeyLoading: false
      };

    case actions.GENERATE_NEW_API_KEY_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        integrationManagementByIdHasError: true,
        integrationManagementByIdLoading: false,
        generateNewAPIKeyLoading: false
      };

    case actions.REUPLOADING_BANK_TRX_DATA:
      return {
        ...state,
        bankFileUploadIsError: false,
        bankFileUploadLoading: true
      };

    case actions.REUPLOAD_BANK_TRX_DATA_SUCCESS:
      return {
        ...state,
        bankFileUploadLoading: action.loading,
        errorMessage: action.message,
        bankFileUploadIsError: false
      };

    case actions.REUPLOAD_BANK_TRX_DATA_FAILED:
      return {
        ...state,
        bankFileUploadLoading: action.loading,
        errorMessage: action.message,
        bankFileUploadIsError: true
      };

    case actions.FETCHING_RECON_AUDIT_LOGS:
      return {
        ...state,
        reconAuditLogs: [],
        reconAuditLogsIsLoading: action.loading,
      }
    
    case actions.FETCH_RECON_AUDIT_LOGS_SUCCESS:
      return {
        ...state,
        reconAuditLogs: action.result,
        reconAuditLogsPagination: action.pagination,
        reconAuditLogsIsLoading: false,
        reconAuditLogsIsError: false,
        reconAuditLogsFilter: action.filter
      };
    case actions.FETCH_RECON_AUDIT_LOGS_FAILED:
      return {
        ...state,
        reconAuditLogs: action.result,
        reconAuditLogsPagination: action.pagination,
        reconAuditLogsIsLoading: false,
        reconAuditLogsIsError: true
      };
    
    case actions.LOADING_MORE_RECON_AUDIT_LOGS:
      return {
        ...state,
        loadingMoreReconAuditLogs: true
      };
    
    case actions.LOAD_MORE_RECON_AUDIT_LOGS_SUCCESS:
      return {
        ...state,
        reconAuditLogs: [...state.reconAuditLogs, ...action.result],
        reconAuditLogsPagination: action.pagination,
        reconAuditLogsIsError: false,
        loadingMoreReconAuditLogs: false,
        reconAuditLogsFilter: action.filter
      };
    
    case actions.LOAD_MORE_RECON_AUDIT_LOGS_FAILED:
      return {
        ...state,
        reconAuditLogsIsError: true,
        loadingMoreReconAuditLogs: false
      };

    case authActions.LOGOUT:
      // reset all redux param values
      return initState;

    default:
      return state;
  }
}
